import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import WeatherEnabledStatus from 'owa-service/lib/contract/WeatherEnabledStatus';
import weatherStore from './../store';
import { pullWeather } from './pullWeather';

// Interval Id of the set interval
let intervalId: NodeJS.Timer = null;

/**
 * Minimum pulling interval for weather task
 */
const WeatherPollingWindowsInMinutes: number = 10;

/**
 * Periodic task for pulling weather into the store
 */
export default function weatherPullTask() {
    // Only pull weather and set interval if user setting for weather is enabled
    if (getUserConfiguration().UserOptions.WeatherEnabled != WeatherEnabledStatus.Disabled) {
        pullWeather();
        // create an interval if there is no existing interval
        if (!intervalId) {
            intervalId = setInterval(
                pullWeather,
                Math.max(weatherStore.pollingWindowInMinutes, WeatherPollingWindowsInMinutes) *
                    TimeConstants.MillisecondsIn1Min
            );
        }
    } else {
        // clear existing interval, if any, if the weather setting has been disabled by the user
        if (intervalId) {
            clearInterval(intervalId);
        }
    }
}
